import { mailIdentity } from './mailDashboardApi';

export function nextImportBatch(rows) {
  const batch = [];
  let size = 0;
  for (const row of rows.slice(0, 20)) {
    const length = JSON.stringify(row).length + 1;
    if (batch.length && size + length > 400000) break;
    batch.push(row); size += length;
  }
  return batch;
}

export async function subscriberRequest(runtime, owner, url, method = 'GET', body) {
  const identity = await mailIdentity(runtime);
  if (identity.attributes.sub !== owner) throw new Error('Your account changed. Reopen Mail Center before continuing.');
  const response = await runtime.fetch(url, { method, headers: { Authorization: `Bearer ${identity.token}`, 'Content-Type': 'application/json' },
    ...(body ? { body: JSON.stringify({ ...body, authorSub: owner, userSub: owner }) } : {}), signal: AbortSignal.timeout(25000) });
  if ((await mailIdentity(runtime)).attributes.sub !== owner) throw new Error('Your account changed. Reopen Mail Center before continuing.');
  const data = await response.json();
  if (!response.ok) throw new Error(data?.message || 'Subscriber request failed. Please retry.');
  if (!data || typeof data !== 'object' || Array.isArray(data)) throw new Error('Invalid subscriber response. Please retry.');
  return data;
}

export function checkedImport(data, emails) {
  const result = {};
  for (const email of emails) {
    const entry = data.results?.[email];
    if (!entry || typeof entry.exists !== 'boolean' || (entry.exists && typeof entry.status !== 'string')) throw new Error('The duplicate check was incomplete. Preview again before importing.');
    result[email] = entry.exists ? entry.status : null;
  }
  return result;
}

export function importOutcomes(data, rows) {
  if (!Array.isArray(data.results) || data.results.length !== rows.length) throw new Error('Import result is uncertain. Preview and retry; existing contacts will be skipped.');
  for (let i = 0; i < rows.length; i++) if (data.results[i]?.email !== rows[i].email || !['added', 'skipped', 'failed'].includes(data.results[i]?.outcome)) throw new Error('Import result is incomplete. Preview and retry safely.');
  return data.results;
}
